module.exports = __webpack_public_path__ + "img/19.85072923.png";